// extracted by mini-css-extract-plugin
export default {"container":"StatisticContainer_container__+JfkF","tableContainer":"StatisticContainer_tableContainer__R6Adv"};